import './Logo.css'

export function Logo() {
  return (
    <div className="jert-logo">
      <div className="logo-icon">
        <svg viewBox="0 0 60 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Eraser body */}
          <rect x="2" y="8" width="36" height="18" rx="2"
                stroke="#e8e8e8" strokeWidth="2" fill="none" opacity="0.9"/>
          {/* Eraser felt bottom */}
          <rect x="2" y="22" width="36" height="6" rx="1"
                stroke="#e8e8e8" strokeWidth="1.5" fill="rgba(232,232,232,0.15)" opacity="0.8"/>
          {/* JERT text on eraser */}
          <text x="10" y="19" fontFamily="Patrick Hand, cursive" fontSize="10" fontWeight="bold"
                fill="#e8e8e8" opacity="0.9">JERT</text>
          {/* Chalk dust trailing - code symbols */}
          <text x="42" y="14" fontFamily="monospace" fontSize="8" fill="#e8e8e8" opacity="0.7">{"{"}</text>
          <text x="48" y="20" fontFamily="monospace" fontSize="7" fill="#e8e8e8" opacity="0.5">{"}"}</text>
          <text x="45" y="27" fontFamily="monospace" fontSize="6" fill="#e8e8e8" opacity="0.4">;</text>
          {/* Dust particles */}
          <circle cx="52" cy="12" r="1" fill="#e8e8e8" opacity="0.3"/>
          <circle cx="55" cy="18" r="1.5" fill="#e8e8e8" opacity="0.25"/>
          <circle cx="54" cy="25" r="1" fill="#e8e8e8" opacity="0.2"/>
          <circle cx="58" cy="22" r="0.8" fill="#e8e8e8" opacity="0.15"/>
        </svg>
      </div>
      <div className="logo-text">
        <span className="logo-title">
          <span className="logo-jert">Jert</span>
          <span className="logo-script">script</span>
          <span className="logo-version">v2</span>
        </span>
        <span className="logo-tagline">Playground</span>
      </div>
    </div>
  )
}
